import { convertDate } from '../../helpers/dateConverter';
import { isReconciled } from '../../helpers/reconciliationHelpers';
import apiClient from './apiClient';

const request = async function (options, store) {
  // 🔍 [API DEBUG] Request Analysis
  if (options.url && options.url.includes('reconciliation-new')) {
    console.group('🔍 [API Request] Reconciliation-New Endpoint');
    console.log('🔗 URL:', options.url);
    console.log('📝 Method:', options.method);
    console.log('📊 Data:', options.data);
    console.groupEnd();
  }

  // success handler
  const onSuccess = function (response) {
    if (response.config.url.includes('ByDate') || response.config.url.includes('Reconciliation')) {
      // Verificar se response.data é um array antes de chamar .map()
      if (Array.isArray(response.data)) {
        response.data.map((entry) => {
          // entry.dateVencimento = entry.dateVencimento.substr(0, 10);
          // entry.dateCompetencia = entry.dateCompetencia.substr(0, 10);
          entry.paymentType = 1;
          if (isReconciled(entry)) {
            entry.isReconciliated = 'Sim';
            entry.statusPayment = true;
            entry.statusString = 'Pago';
          } else {
            entry.isReconciliated = 'Não';
            if (entry.statusPayment === true) {
              entry.statusString = 'Pago';
            } else if (
              entry.dateVencimento < convertDate(new Date()) &&
              entry.journalEntryType === 1
            ) {
              entry.statusString = 'Vencido';
            } else {
              entry.statusString = 'Pendente';
            }
          }
          // if (entry.journalEntryType === 1) {
          if (entry.isInput) {
            entry.entryType = 'Entrada';
          } else {
            entry.entryType = 'Saída';
          }
          // }
          if (entry.journalEntryType === 5) {
            entry.entryType = 'Transferência';
          }
          if (entry.journalEntryType === 2) {
            entry.entryType = 'Saldo Inicial';
          }
          entry.dateVencimento = entry.dateVencimento.substr(0, 10);
          entry.dateCompetencia = entry.dateCompetencia.substr(0, 10);

          return entry;
        });
      }
    }

    return response;
  };

  // error handler
  const onError = function (error) {
    console.error('[Request] Error details:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      hasResponse: !!error.response,
      config: error.config,
    });
    return Promise.reject(error);
  };

  // adding success and error handlers to apiClient
  return apiClient(options).then(onSuccess).catch(onError);
};

export default request;
